<!--
 * @Description: 
 * @Author: liusilin
 * @Date: 2024-07-10 11:59:18
 * @LastEditors: liusilin
 * @LastEditTime: 2024-10-12 16:26:31
-->
<template>
  <div class="pages member">
    <div class="container">
      <p>
        <strong
          >更新时间：2023年10月10日<br />
          生效时间：2023年10月10日</strong
        >
      </p>
      <p>
        <strong>重要提示</strong><br />
        欢迎使用由杭州摸鲸科技有限公司（以下简称“摸鲸科技”）提供的熊猫绘画付费服务(以下简称“付费会员”)，在使用付费会员服务之前，<strong
          >请认真阅读《熊猫绘画会员服务协议》（以下简称“本协议”）所有内容，特别是加粗部分。未成年人则应在法定监护人陪同下阅读。确保您充分理解本协议中各条款，包括免除摸鲸科技责任的条款和限制会员权利的条款。请您审慎阅读并选择接受或不接受本服务条款。除非您接受本协议所有条款，否则您无权使用付费会员服务。您对付费会员服务的购买或使用行为即视为您已阅读并同意接受本协议的约束。</strong
        >
      </p>
      <p>
        付费会员服务是有偿的增值服务，您必须同意本协议条款，并完成付费，才能享受付费会员相关服务。本协议是摸鲸科技与您之间关于获取/使用付费会员服务的约定，为熊猫绘画《用户协议》、《隐私政策》的补充协议。摸鲸科技已发布或将来可能发布关于付费会员服务的各项规范、规则等也是本服务条款的一部分，上述内容一经正式发布即生效，对双方均具约束力。
      </p>
      <p>
        本协议及相关服务条款如由于业务发展进行修订的，摸鲸科技将在熊猫绘画软件公布。您可前往查阅最新版协议条款。在摸鲸科技修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用付费会员服务。您继续使用本服务的，将被是为已接受了修改后的协议，更新后的协议自发布之日起生效。
      </p>
      <p>
        <strong>1 付费会员服务内容</strong><br />
        1.1熊猫绘画付费会员是指摸鲸科技为您提供的网络增值服务，包括普通会员和年费会员。您在成为付费会员后可以享有会员页面展示的权益，具体权益内容以会员页面展示为准。付费会员的所有权和运营权，以及付费会员制度和活动的制定权均归摸鲸科技公司所有。<br />
        <strong
          >1.2请您注意，普通会员和年费会员服务权益存在差异，如果您已经是普通会员，不可以通过加价升级为年费会员。年费会员需要单独购买。</strong
        ><br />
        1.3请您理解，摸鲸科技有权根据法律法规、业务发展情况调整（包括取消、新增、减少等）权益类型，摸鲸科技将在“会员中心”页面或其他合理位置公布或向您发送通知，建议您仔细阅读。我们将尽力确保上述调整不损害会员已有利益，如果您继续使用付费会员服务，即表明您同意接受相应调整。如果您不同意前述调整内容，请您立即停止使用付费会员服务。<br />
        1.4如果您订购的自动续费类会员服务，请仔细阅读并同意《自动续费服务协议》，该协议为本协议的补充协议。<br />
        1.5请您知悉，摸鲸科技公司有权根据实际运营情况，向非会员用户或不同类型会员用户提供部分或完整会员权益，如活动奖励等。
      </p>
      <p>
        <strong>2 付费会员的开通和终止</strong><br />
        2.1如果您有需求获取付费会员权益，需先登录您的熊猫绘画账号，或注册熊猫绘画账号并登录。成功登录后，依约支付费用开通会员；或者通过官方活动或他人赠与的方式获得会员。会员价格可能因为您使用的软件的版本不同而产生差异，以开通服务时显示的金额为准。<br />
        2.2您在开通会员服务时，请仔细确认账号名称和开通类型等信息，如因您个人原因造成充错账号或错选服务时长，摸鲸科技不予退还已收取的费用。<br />
        2.3会员资格有效期自付费会员服务开通之时起算，具体期限可以登录熊猫绘画客户端“会员中心”页查看。<br />
        <strong
          >2.4付费会员服务仅限于订购账号自行使用，不能在熊猫绘画账号之间转移。</strong
        ><br />
        <strong
          >2.5请您知悉，付费会员服务是一项特殊服务，已开通的付费会员服务不能转让或退款。（如因熊猫绘画会员服务存在重大问题导致您无法正常使用，依据本协议和法律法规，您可通过客服联系摸鲸科技判断后认为可以退款等除外）。</strong
        >
      </p>
      <p>
        <strong>3 会员的权利和义务</strong><br />
        3.1您成为付费会员后将享有各项会员专属特权，您可在“会员中心”页面查看特权内容。<br />
        3.2您不得采取出售、转让、盗用、租赁、共用等其他方式进行付费会员开通或通过出售、转让、盗用、租赁、共用等其他方式享用会员。<br />
        3.3如果您违反本协议或用户协议，摸鲸科技有权利采用以下一项或者多项措施处理：<br />
        <strong
          >3.3.1采取技术手段，删除、屏蔽或断开相关信息。<br />
          3.3.2修改、限制、终止全部会员特权或部分会员特权。<br />
          3.3.3您在使用付费会员期间，应遵守法律法规及其他规范性文件，包括但不限于《中华人民共和国保护国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《中华人民共和国网络安全法》、《信息网络传播权保护条例》等；应遵守公共秩序，尊重社会道德，不危害网络安全，不利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，分裂国家，破坏统一，宣扬恐怖主义，极端主义，民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱公共秩序，损害他人名誉、隐私、知识产权等。在任何情况下，一旦合理的认定您存在上述行为的，可以不经事先通知终止向您提供会员服务。</strong
        >
      </p>
      <p>
        <strong>4 摸鲸科技的义务</strong><br />
        摸鲸科技有义务遵守本协议条款、熊猫绘画《用户协议》及各项规范、规则会员正常使用会员服务的同时，尽最大努力确保会员服务的稳定性，为此提供各项技术及客服支持，包括但不限于：<br />
        4.1开通会员服务时所遇到的注册、登录、购买、赠送等问题的网上咨询客服服务。<br />
        4.2会员服务期间产生的常见问题解答、基本规则解释。<br />
        4.3我们会尽最大努力提高软件技术，保障会员服务的稳定性。<br />
        4.4摸鲸科技提供给您的其他技术支持或服务。
      </p>
      <p>
        <strong>5 隐私保护</strong><br />
        您理解并同意按照熊猫绘画《隐私政策》的约定处理和保护您的个人信息。
      </p>
      <p>
        <strong>6 未成年人保护</strong><br />
        6.1根据国家法律规定，若您为未满18周岁的未成年人，您应在监护人的陪同和指导下阅读本协议。<br />
        6.2若您的监护人同意您订购付费会员，则应当以监护人的名义完成交易，您使用付费会员服务，以及行使和履行本协议的权利和义务即视为已过的了监护人的同意。<br />
        6.3请未成年人用户注意保护个人信息，合理安全使用软件时间，避免沉迷，影响日常学习。
      </p>
      <p>
        <strong>7其他约定</strong><br />
        7.1服务中止、中断和终止，摸鲸科技根据自身商业决策，政府行为、不可抗力等原因可能会选择更改、中断、中止和终止全部或部分付费会员服务。如有上述情况发生，摸鲸科技会通知您，但不承担由此对您造成的任何损失。除法律法规明确规定情形外，摸鲸科技有权不经您申请，直接向您退还履行的付费会员服务对应的费用。<br />
        7.2本协议解释，效力及纠纷的解决，适用中华人民共和国法律。若会员和摸鲸科技之间发生任何纠纷或争议，首先应尽量友好协商解决，协商不成时，任何一方均可向被告住所地享有管辖权的人民法院提起诉讼。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Member",
  components: {},
  computed: {},
  created() {},
  methods: {}
};
</script>

<style lang="scss">
.member {
  .container {
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
